import { defineNuxtPlugin, useRuntimeConfig, useScript } from '#imports'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { noop } from '@backmarket/utils/function/noop'

declare global {
  interface Window {
    dbbRum?: Array<[string, unknown]>
  }
}

export {}

export default defineNuxtPlugin(() => {
  if (!import.meta.env.PROD) return

  const { public: config } = useRuntimeConfig()
  const { market } = useMarketplace()
  const countries = config.FF_ENABLE_DEBUGBEAR_RUM_COUNTRIES as string

  if (!countries || !countries.includes(market.countryCode)) return

  // Sampling rate - currently 25%
  const samplingRate = 25
  if (Math.random() * 100 >= samplingRate) return

  window.dbbRum = window.dbbRum || []
  window.dbbRum.push(['presampling', samplingRate])
  ;['error', 'unhandledrejection'].forEach((t) => {
    window.addEventListener(t, (e) => {
      window.dbbRum?.push([t, e])
    })
  })

  const { load } = useScript(
    {
      id: 'debugbear-rum',
      src: 'https://cdn.debugbear.com/0rEkqZCYNO4y.js',
      async: true,
    },
    { trigger: 'onNuxtReady' },
  )

  void load().catch(() => noop)
})
